<template>

  <div class="login-container">
    <div class="login-form">
      <img src="@/assets/logo_full.png"/>
      <input v-model="username" />
      <input v-model="password" type="password" @keyup.enter="login"/>
      <Button class="login-bt" @click="login">
        <div class="login-bt-label">{{ loading ? '...' : 'Login' }}</div>
      </Button>
      <p class="status" v-if="status !== ''">{{ status }}</p>
    </div>
  </div>

</template>

<script>

import Button from '@/components/common/Button'

export default {
  name: 'Login',
  components: {
    Button
  },
  data () {
    return {
      username: '',
      password: '',
      status: '',
      loading: false
    }
  },
  methods: {
    login () {
      this.status = ''
      this.loading = true
      setTimeout(() => {
        this.$store.dispatch('login', {
          username: this.username,
          password: this.password
        })
          .then(user => {
            this.$router.push('/')
            this.loading = false
          })
          .catch(resp => {
            this.status = 'CONNECTION FAILED'
            this.loading = false
            console.error(resp)
          })
      }, 2000)
    }
  },
  mounted () {
    this.username = 'hello'
  }
}

</script>

<style lang="scss" scoped>

@import "../styles/main-colors";

.login-container {
  background-color: $background-dark;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
  align-content: center;
  align-items: center;
  justify-items: center;
};

.login-form {
  background-color: $background-grey;
  display: grid;
  grid-template-columns: 500px;
  grid-template-rows: 200px 50px 50px auto 15px;
  grid-row-gap: 15px;
  padding: 50px;
  width: fit-content;
}

img {
  width: auto;
  height: 150px;
  justify-self: center;
}

input {
  padding: 5px;
  background-color: white;
}

.login-bt {
  background-color: $secondary-color;
}

.login-bt-label {
  padding: 5px;
}

.status {
  color: $detail-color;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/pages/Login.vue